/**
 * Outcome of asking whether future bookings should follow a station change.
 *
 * These are four genuinely different situations and must not be collapsed. Station propagation
 * defaults to ON server-side, so anything the caller does not state explicitly is read as approval —
 * which means a silent `undefined` on failure would cascade a mass change nobody approved.
 */
export enum FutureBookingsConfirmOutcome {
  /** No station field was touched — the question does not arise; say nothing. */
  NotApplicable = "NotApplicable",
  /** The admin approved the cascade. */
  Approved = "Approved",
  /** The admin declined; the "no" must be sent explicitly. */
  Declined = "Declined",
  /**
   * A station field changed but the server reported nothing would move. Sent as an explicit "no"
   * rather than silence: between the preview and the save a matching booking may appear (bulk updates
   * are processed asynchronously), and it must not be changed on the strength of a stale zero.
   */
  NoImpact = "NoImpact",
  /** The impact could not be determined. The caller must abort rather than guess. */
  PreviewFailed = "PreviewFailed",
}
